<main class="mx-auto w-full max-w-3xl pb-12 text-strong">
    <a [routerLink]="['/users/profile', athleteId]"
       class="mb-5 inline-flex min-h-[40px] items-center gap-2 text-sm font-medium !text-slate-600 hover:!text-primary">
        <i class="bi bi-arrow-left" aria-hidden="true"></i> Torna al profilo atleta
    </a>

    <header class="mb-6">
        <h1 class="m-0 text-2xl font-bold tracking-tight text-strong sm:text-3xl">Nuova iscrizione</h1>
        <p class="mb-0 mt-2 text-sm leading-6 text-slate-600">
            Scegli la categoria e il metodo di pagamento<ng-container *ngIf="currentSeason?.name"> per la stagione {{ currentSeason?.name }}</ng-container>.
        </p>
    </header>

<div *ngIf="loading" class="subscription-card animate-pulse" role="status" aria-label="Caricamento">
    <div class="subscription-card-inner flex flex-col gap-4">
        <div class="h-6 w-64 max-w-full rounded bg-slate-200"></div>
        <div class="h-11 rounded-xl bg-slate-100"></div>
        <div class="h-20 rounded-xl bg-slate-100"></div>
    </div>
</div>

<div class="subscription-card" *ngIf="!loading">
    <div class="subscription-card-inner">
        <!-- Sconto fratelli -->
        <div *ngIf="siblingDiscount?.eligible && !reviewing"
             class="mb-6 flex items-start gap-3 rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-3">
            <span class="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-white text-lg text-emerald-600">
                <i class="bi bi-people-fill" aria-hidden="true"></i>
            </span>
            <div class="min-w-0 text-sm leading-6 text-emerald-900">
                <p class="m-0 font-bold">Questo account ha diritto allo sconto fratelli</p>
                <p class="m-0">
                    <ng-container *ngIf="siblingDiscount?.sibling as sibling">
                        {{ sibling.firstName }} {{ sibling.lastName }} ha richiesto l'iscrizione a questa stagione il
                        {{ sibling.requestedAt | date:'dd/MM/yyyy':'':'it' }}, quindi
                    </ng-container>
                    per questa iscrizione si applica il prezzo ridotto della categoria scelta.
                </p>
                <p class="m-0 text-xs text-emerald-800/80">Lo sconto spetta a chi richiede l'iscrizione dopo un fratello nella stessa stagione, anche in una categoria diversa e anche se il fratello non ha ancora pagato.</p>
            </div>
        </div>

        <!-- Riepilogo -->
        <section *ngIf="reviewing" aria-labelledby="review-title" class="flex flex-col gap-4">
            <div>
                <h2 id="review-title" class="m-0 text-lg font-bold text-strong">Riepilogo</h2>
                <p class="mb-0 mt-1 text-sm text-slate-600">Controlla i dati prima di confermare il pagamento.</p>
            </div>

            <dl class="m-0 divide-y divide-slate-100 rounded-xl border border-slate-200 px-4">
                <div *ngIf="athleteName" class="flex flex-col gap-0.5 py-3 sm:flex-row sm:justify-between sm:gap-4">
                    <dt class="text-sm font-normal text-slate-500">Atleta</dt>
                    <dd class="m-0 text-sm font-semibold text-strong sm:text-right">{{ athleteName }}</dd>
                </div>
                <div class="flex flex-col gap-0.5 py-3 sm:flex-row sm:justify-between sm:gap-4">
                    <dt class="text-sm font-normal text-slate-500">Categoria</dt>
                    <dd class="m-0 text-sm font-semibold text-strong sm:text-right">
                        {{ selectedCategory?.name }}<span *ngIf="currentSeason?.name" class="block text-xs font-normal text-slate-500">Stagione {{ currentSeason?.name }}</span>
                    </dd>
                </div>
                <div *ngIf="invoiceRecipients" class="flex flex-col gap-0.5 py-3 sm:flex-row sm:justify-between sm:gap-4">
                    <dt class="text-sm font-normal text-slate-500">Ricevuta intestata a</dt>
                    <dd class="m-0 text-sm font-semibold text-strong sm:text-right">{{ invoiceRecipients }}</dd>
                </div>
                <div class="flex flex-col gap-0.5 py-3 sm:flex-row sm:justify-between sm:gap-4">
                    <dt class="text-sm font-normal text-slate-500">Metodo di pagamento</dt>
                    <dd class="m-0 text-sm font-semibold text-strong sm:text-right">{{ paymentMethodLabel() }}</dd>
                </div>
            </dl>

            <div class="rounded-xl bg-slate-50 px-4 py-3">
                <div class="flex items-baseline justify-between gap-4 py-1 text-sm">
                    <span class="text-slate-600">Quota di iscrizione</span>
                    <span class="flex items-baseline gap-2">
                        <span *ngIf="hasDiscount(selectedCategory)" class="text-slate-400 line-through">{{ formatAmount(+(selectedCategory?.fullPrice ?? 0)) }}</span>
                        <span class="font-semibold text-strong">{{ formatAmount(getCategoryAmount()) }}</span>
                    </span>
                </div>
                <div *ngIf="hasDiscount(selectedCategory)" class="flex justify-between gap-4 py-1 text-sm text-emerald-700">
                    <span>Sconto fratelli</span>
                    <span>−{{ formatAmount(+(selectedCategory?.fullPrice ?? 0) - getCategoryAmount()) }}</span>
                </div>
                <div *ngIf="commissionPercent" class="flex justify-between gap-4 py-1 text-sm text-slate-600">
                    <span>Commissione pagamento a rate ({{ commissionPercent }}%)</span>
                    <span>+{{ formatAmount(totalAmount - getCategoryAmount()) }}</span>
                </div>
                <div class="mt-2 flex items-baseline justify-between gap-4 border-0 border-t border-solid border-slate-200 pt-3">
                    <span class="text-sm font-semibold text-strong">Totale</span>
                    <strong class="text-xl font-bold text-strong">{{ formatAmount(totalAmount) }}</strong>
                </div>
            </div>

            <p class="m-0 flex items-start gap-2 text-xs leading-5 text-slate-500">
                <i class="bi bi-info-circle mt-0.5 shrink-0" aria-hidden="true"></i>
                Dopo la conferma la richiesta di iscrizione viene inviata alla società e non potrà essere modificata.
            </p>
        </section>

        <div class="container-fluid px-0" [hidden]="reviewing">
            <form #paymentForm="ngForm" class="payment-form flex flex-col gap-4">
                <div class="flex flex-col gap-2">
                    <label for="payment-category" class="form-label required">Categoria</label>
                    <select required name="category" id="payment-category"
                            class="form-control form-select w-full"
                            [(ngModel)]="categorySelected">
                        <option value="">Seleziona una categoria</option>
                        <option *ngFor="let category of categories" [value]="category.id">
                            {{ category.name }} — {{ priceFor(category) | currency:'EUR':'symbol':'1.2-2':'it' }}{{ hasDiscount(category) ? ' (scontato)' : '' }}
                        </option>
                    </select>
                    <p *ngIf="!categories.length" class="m-0 text-sm text-slate-500">Nessuna categoria disponibile per la stagione corrente.</p>
                </div>

                <!-- Riepilogo importo -->
                <div *ngIf="selectedCategory as category"
                     class="flex flex-wrap items-center justify-between gap-3 rounded-xl border border-slate-200 bg-slate-50 px-4 py-3">
                    <div class="min-w-0">
                        <p class="m-0 text-xs font-semibold uppercase tracking-wide text-slate-500">Quota di iscrizione</p>
                        <p class="m-0 truncate text-sm text-slate-700">{{ category.name }}</p>
                    </div>
                    <div class="flex items-baseline gap-2">
                        <span *ngIf="hasDiscount(category)" class="text-sm text-slate-400 line-through">
                            {{ category.fullPrice | currency:'EUR':'symbol':'1.2-2':'it' }}
                        </span>
                        <strong class="text-xl font-bold text-strong">{{ priceFor(category) | currency:'EUR':'symbol':'1.2-2':'it' }}</strong>
                        <span *ngIf="hasDiscount(category)" class="rounded-md bg-emerald-100 px-2 py-0.5 text-xs font-semibold text-emerald-800">Sconto fratelli</span>
                    </div>
                </div>

                <ng-container>
                    <div *ngIf="userType === 'userParent' && !athleteParents.length" class="payment-alert">
                        Attenzione! Non hai nessun genitore registrato, per registrarlo
                        <a [routerLink]="['/users/edit-parents/', athleteId]">clicca qui</a>
                    </div>

                    <ng-container *ngIf="athleteParents.length > 0">
                        <div>
                            <div class="form-label required mb-1">Ricevuta intestata a</div>
                            <p class="payment-field-hint">Seleziona uno o più genitori a cui intestare la ricevuta.</p>
                            <div class="payment-method-grid mt-2">
                                <div class="payment-method-option" *ngFor="let parent of athleteParents">
                                    <input class="payment-method-input" type="checkbox"
                                           [id]="'parent-' + parent.id"
                                           (change)="selectParent(parent)">
                                    <label class="payment-method-card" [for]="'parent-' + parent.id">
                                        <span class="payment-method-icon" aria-hidden="true">
                                            <svg fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                      d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"/>
                                            </svg>
                                        </span>
                                        <span class="payment-method-text">
                                            <span class="payment-method-title">{{ parent.firstName }} {{ parent.lastName }}</span>
                                            <span class="payment-method-desc">Intestatario ricevuta / fattura</span>
                                        </span>
                                    </label>
                                </div>
                            </div>
                            <div *ngIf="userType === 'userParent' && !parentComplete()" class="alert alert-danger mt-2 mb-0">
                                Prima di procedere,
                                <a [routerLink]="['/users/edit-parents/', athleteId]">completa il profilo del genitore</a>
                            </div>
                        </div>
                    </ng-container>

                    <div>
                        <label class="form-label required">Metodo di pagamento</label>
                        <div class="payment-method-grid mt-1"
                             *ngIf="wireTransferEnabled || nexiEnabled || nexiRatesEnabled || localPaymentEnabled || appPagoRatesEnabled || posNexiEnabled">
                            <div class="payment-method-option" *ngIf="wireTransferEnabled">
                                <input required class="payment-method-input" type="radio" name="payment-method"
                                       id="wire-transfer-method" value="transfer" [(ngModel)]="paymentMethod">
                                <label for="wire-transfer-method" class="payment-method-card">
                                    <span class="payment-method-icon" aria-hidden="true">
                                        <svg fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                  d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0012 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75z"/>
                                        </svg>
                                    </span>
                                    <span class="payment-method-text">
                                        <span class="payment-method-title">Bonifico bancario</span>
                                        <span class="payment-method-desc">Ricevi le istruzioni per il bonifico</span>
                                    </span>
                                </label>
                            </div>
                            <!--<div class="form-check" *ngIf="soisyEnabled">
                                <input required class="form-check-input" type="radio" name="payment-method" id="soisy-method" value="soisy" [(ngModel)]="paymentMethod">
                                <label class="form-check-label" for="soisy-method">Soisy</label>
                            </div>-->
                            <div class="payment-method-option" *ngIf="nexiEnabled">
                                <input required class="payment-method-input" type="radio" name="payment-method"
                                       id="nexi-method" value="nexi" [(ngModel)]="paymentMethod">
                                <label for="nexi-method" class="payment-method-card">
                                    <span class="payment-method-icon" aria-hidden="true">
                                        <svg fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                  d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v12.75A2.25 2.25 0 004.5 19.5z"/>
                                        </svg>
                                    </span>
                                    <span class="payment-method-text">
                                        <span class="payment-method-title">Nexi</span>
                                        <span class="payment-method-desc">Carta di credito o debito, pagamento immediato</span>
                                    </span>
                                </label>
                            </div>
                            <div class="payment-method-option" *ngIf="nexiRatesEnabled">
                                <input required class="payment-method-input" type="radio" name="payment-method"
                                       id="nexiRates-method" value="nexiRates" [(ngModel)]="paymentMethod">
                                <label for="nexiRates-method" class="payment-method-card">
                                    <span class="payment-method-icon" aria-hidden="true">
                                        <svg fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                  d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0h10.5m4.5 0h2.25M12.75 6.75h.008v.008H12.75V6.75zm0 3h.008v.008H12.75V9.75zm0 3h.008v.008H12.75v-.008zm0 3h.008v.008H12.75v-.008z"/>
                                        </svg>
                                    </span>
                                    <span class="payment-method-text">
                                        <span class="payment-method-title">
                                            Rate mensili PagoDIL
                                            <span *ngIf="company.nexiRatesCommissionPercent && +company.nexiRatesCommissionPercent !== 0"
                                                  class="payment-commission">(+ %{{ company.nexiRatesCommissionPercent }})</span>
                                        </span>
                                        <span class="payment-method-desc">Dilazione del pagamento in comode rate</span>
                                    </span>
                                </label>
                            </div>
                            <div class="payment-method-option" *ngIf="appPagoRatesEnabled">
                                <input required class="payment-method-input" type="radio" name="payment-method"
                                       id="appPagoRates-method" value="appPagoRates" [(ngModel)]="paymentMethod">
                                <label for="appPagoRates-method" class="payment-method-card">
                                    <span class="payment-method-icon" aria-hidden="true">
                                        <img src="assets/icons/appPago.svg" alt="" class="h-6 w-auto">
                                    </span>
                                    <span class="payment-method-text">
                                        <span class="payment-method-title">
                                            Rate AppPago
                                            <span *ngIf="company.appPagoCommissionPercent && +company.appPagoCommissionPercent !== 0"
                                                  class="payment-commission">(+ %{{ company.appPagoCommissionPercent }})</span>
                                        </span>
                                        <span class="payment-method-desc">Dilazione del pagamento in comode rate</span>
                                    </span>
                                </label>
                            </div>
                            <div class="payment-method-option" *ngIf="localPaymentEnabled || posNexiEnabled">
                                <input required class="payment-method-input" type="radio" name="payment-method"
                                       id="local-payment-method" value="localPayment" [(ngModel)]="paymentMethod">
                                <label for="local-payment-method" class="payment-method-card">
                                    <span class="payment-method-icon" aria-hidden="true">
                                        <svg fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                  d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h.007v.008H9V6.75zm0 3h.007v.008zm4.5-3h.007v.008H13.5V6.75zm0 3h.007v.008zm0 3h.007v.008H13.5V9.75zm0 3h.007v.008H13.5v-.008zm0 3h.007v.008H13.5v-.008z"/>
                                        </svg>
                                    </span>
                                    <span class="payment-method-text">
                                        <span class="payment-method-title">
                                            <ng-container *ngIf="localPaymentEnabled && posNexiEnabled">
                                                Pagamento in segreteria contanti o Pos
                                            </ng-container>
                                            <ng-container *ngIf="localPaymentEnabled && !posNexiEnabled">
                                                Pagamento in segreteria SOLO contanti
                                            </ng-container>
                                            <ng-container *ngIf="!localPaymentEnabled && posNexiEnabled">
                                                Pagamento in segreteria SOLO Pos
                                            </ng-container>
                                        </span>
                                        <span class="payment-method-desc">Completa il pagamento presso la società</span>
                                    </span>
                                </label>
                            </div>
                        </div>
                        <p *ngIf="!wireTransferEnabled && !nexiEnabled && !nexiRatesEnabled && !localPaymentEnabled && !appPagoRatesEnabled && !posNexiEnabled"
                           class="payment-empty-methods">
                            Ancora nessun metodo di pagamento impostato dalla società
                        </p>
                    </div>

                    <div>
                        <div class="form-label required mb-1.5">Privacy e condizioni</div>
                        <label for="terms-and-conditions"
                               class="m-0 flex cursor-pointer items-start gap-3 rounded-xl border px-4 py-3 transition"
                               [ngClass]="termsAndConditions ? 'border-primary bg-primary-soft' : 'border-slate-200 bg-white hover:border-slate-300'">
                            <input name="terms" required class="form-check-input !m-0 !mt-0.5 shrink-0" type="checkbox"
                                   id="terms-and-conditions" [(ngModel)]="termsAndConditions">
                            <span class="text-sm leading-6 text-slate-700">
                                Ho letto e accetto i termini e le condizioni del servizio<ng-container *ngIf="company.privacyPolicyUrl"> e la
                                <a [href]="company.privacyPolicyUrl" target="_blank" rel="noopener" class="font-semibold underline"
                                   (click)="$event.stopPropagation()">privacy policy</a></ng-container>.
                            </span>
                        </label>
                    </div>
                </ng-container>
            </form>
        </div>

        <div class="payment-card-footer">
            <form #nexiForm ngNoForm method="POST" action="{{ getNexiUrl() }}">
                <input type="hidden" name="alias" [value]="nexiAlias"/>
                <input type="hidden" name="importo" [value]="importo"/>
                <input type="hidden" name="divisa" [value]="divisa"/>
                <input type="hidden" name="codTrans" [value]="codTrans"/>
                <input type="hidden" name="url" [value]="url"/>
                <input type="hidden" name="url_back" [value]="url_back"/>
                <input type="hidden" name="mac" [value]="nexiMac"/>
                <input type="hidden" name="email" [value]="email"/>
                <input type="hidden" name="3dsDinamico" [value]="value3dsDinamico"/>
                <input type="hidden" name="urlpost" [value]="urlpost"/>
            </form>

            <form #nexiRatesForm ngNoForm method="POST" action="{{ getNexiUrl() }}">
                <input type="hidden" name="alias" [value]="nexiRatesAlias"/>
                <input type="hidden" name="importo" [value]="importo"/>
                <input type="hidden" name="divisa" [value]="divisa"/>
                <input type="hidden" name="codTrans" [value]="codTrans"/>
                <input type="hidden" name="url" [value]="url"/>
                <input type="hidden" name="url_back" [value]="url_back"/>
                <input type="hidden" name="mac" [value]="nexiRatesMac"/>
                <input type="hidden" name="email" [value]="email"/>
                <input type="hidden" name="3dsDinamico" [value]="value3dsDinamico"/>
                <input type="hidden" name="urlpost" [value]="urlpost"/>
                <input type="hidden" name="nome" [value]="getLocalStorage('wisper_firstname')"/>
                <input type="hidden" name="cognome" [value]="getLocalStorage('wisper_lastname')"/>
                <input type="hidden" name="mail" [value]="getValidMail(email)"/>
                <input type="hidden" name="itemsNumber" [value]="'1'"/>
                <input type="hidden" name="Item_code_1" [value]="'WELLDONE'"/>
                <input type="hidden" name="Item_quantity_1" [value]="'1'"/>
                <input type="hidden" name="Item_amount_1" [value]="'10'"/>
                <input type="hidden" name="Item_description_1" [value]="'WELL DONE'"/>
                <input type="hidden" name="TCONTAB" [value]="'C'"/>
                <input type="hidden" name="shipIndicator" [value]="'05'"/>
                <input type="hidden" name="selectedcard" value="PAGODIL"/>
            </form>

            <ng-container *ngIf="!reviewing; else reviewActions">
                <button type="button"
                        class="btn btn-primary inline-flex min-h-[44px] items-center justify-center gap-2 py-2 px-4 font-semibold"
                        (click)="goToReview()"
                        [disabled]="paymentForm.invalid || disablePayBtn() || (userType === 'userParent' && !athleteParents.length)">
                    Continua <i class="bi bi-arrow-right" aria-hidden="true"></i>
                </button>
            </ng-container>
            <ng-template #reviewActions>
                <div class="flex w-full flex-col-reverse gap-2 sm:flex-row sm:justify-end">
                    <button type="button" class="btn welldone-btn-gray inline-flex min-h-[44px] items-center justify-center gap-2 py-2 px-4"
                            (click)="editPayment()">
                        <i class="bi bi-pencil" aria-hidden="true"></i> Modifica
                    </button>
                    <button type="button" class="btn btn-primary inline-flex min-h-[44px] items-center justify-center gap-2 py-2 px-4 font-semibold"
                            (click)="createPaymentRequest()">
                        <i class="bi bi-lock" aria-hidden="true"></i> Conferma e paga {{ formatAmount(totalAmount) }}
                    </button>
                </div>
            </ng-template>
        </div>
    </div>
</div>
</main>
